import { initStore, SESSIONS_SEARCH_TYPES } from '../../../common';
import { actions } from './actions';

export const playerSessionsStore = (): void => {
	const initialState = {
		slice: 'PLAYER_SESSIONS',
		sessions: [],
		transactions: [],
		pagesTotalTransactions: 1,
		currentPageTransactions: 1,
		sessionsLoading: false,
		isFilterValid: false,
		partners: [],
		games: [],
		sessionStatuses: [],
		devices: [],
		perPage: '10',
		providers: [],
		pagesTotal: 1,
		currentPage: 1,
		rows: [],
		columns: [],
		initialColumns: [],
		columnsTransactions: [
			'Transaction ID',
			'Session ID',
			'Player ID',
			'Ext Player ID',
			'Partner',
			'Skin',
			'TP Trx ID',
			'Provider',
			'Status',
			'Currency',
			'Amount',
			'Original Amount',
			'Balance',
			'Type',
			'Session Type',
			'Created',
			'Finished',
			'AAMS Ticket ID',
			'Hand Details',
		],
		transactionsRows: [],
		filtering: false,
		filters: [
			{
				name: 'searchType',
				value: SESSIONS_SEARCH_TYPES[0].value,
			},
		],
		globalErrors: [],
		globalSuccess: '',
	};

	initStore(actions, initialState);
};
